module.exports = __webpack_public_path__ + "static/img/3122_phase_function_Paper_PointsHejduk_Prediction.19cbe85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3122_phase_function_Paper_PointsHejduk_Prediction.png
// module id = lLEd
// module chunks = 0